import { render, staticRenderFns } from "./IntegrationVariantDetail.vue?vue&type=template&id=0195b7b4"
import script from "./IntegrationVariantDetail.vue?vue&type=script&lang=js"
export * from "./IntegrationVariantDetail.vue?vue&type=script&lang=js"
import style0 from "./IntegrationVariantDetail.vue?vue&type=style&index=0&id=0195b7b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports